export type UqualProgramEligibilityInput = {
  isCreditScoreLow: boolean | undefined;
  isCreditScoreLoading: boolean;
  uQualFlagEnabled: boolean | undefined;
  isUqualSelfReferralDone: boolean | undefined;
  isDashboardLoading: boolean;
  selfReferralInSession: boolean;
  isInitialUqualReferral: boolean;
};

/**
 * Returns whether the user qualifies for the Uqual program.
 * `undefined` means eligibility is still being determined (data loading).
 */
export function getUqualProgramEligibility({
  isCreditScoreLow,
  isCreditScoreLoading,
  uQualFlagEnabled,
  isUqualSelfReferralDone,
  isDashboardLoading,
  selfReferralInSession,
  isInitialUqualReferral,
}: UqualProgramEligibilityInput): boolean | undefined {
  if (isCreditScoreLoading || isDashboardLoading) {
    return undefined;
  }

  if (!isCreditScoreLow || !uQualFlagEnabled) {
    return false;
  }

  if (selfReferralInSession) {
    return isInitialUqualReferral;
  }

  return !isUqualSelfReferralDone;
}
